import { httpClient } from "./api";

export const simulateFixedIncome = (payload) =>
  httpClient.post("/fixed-income/simulate", payload);

export const createFixedIncome = (payload) =>
  httpClient.post("/fixed-income/create", payload);

export const bulkCreateFixedIncome = (payload) =>
  httpClient.post("/fixed-income/bulk-create", payload);

export const getUserFixedIncomeInvestments = (userId) =>
  httpClient.get(`/fixed-income/user/${userId}`);

export const listFixedIncomeOpportunities = () =>
  httpClient.get("/opportunities/fixed-income");

export const listFixedIncomeRequests = () =>
  httpClient.get("/fixed-income/requests");

const fixedIncomeApi = {
  simulateFixedIncome,
  createFixedIncome,
  bulkCreateFixedIncome,
  getUserFixedIncomeInvestments,
  listFixedIncomeOpportunities,
  listFixedIncomeRequests,
};

export default fixedIncomeApi;
